import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {
  @Input() selected: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
